// Workshop services and prices (RD$), cheapest first. The home page and the booking form both read
// from here; `id` is the value saved in maintenance_bookings.maintenance_type.
const FULL_INCLUDES = ['Lavado premium', 'Engrase de cadena', 'Ajuste de cambios', 'Desarme completo', 'Engrase de rodamientos'];

export const MAINTENANCE_SERVICES = [
    { id: 'Lavado', name: 'Servicio de Lavado', short: 'Lavado', price: 500, includes: ['Lavado premium'], note: 'Entrega en 1 hora' },
    { id: 'Basic', name: 'Mantenimiento Básico', short: 'Básico', price: 850, includes: ['Lavado premium', 'Engrase de cadena', 'Ajuste de cambios'] },
    { id: 'Full', name: 'Mantenimiento Full', short: 'Full', price: 1350, includes: FULL_INCLUDES, recommended: true },
    { id: 'Platinum', name: 'Mantenimiento Platinum', short: 'Platinum', price: 2000, includes: FULL_INCLUDES, note: 'Entrega el mismo día' }
];

// Pick-up and delivery ("buscar y llevar")
export const DELIVERY_ZONES = [
    { zone: 'Distrito Nacional', price: 'GRATIS' },
    { zone: 'Santo Domingo Este, Norte y Oeste', price: 'RD$1,000 – 1,450' }
];

export const formatRD = (amount) => `RD$${amount.toLocaleString('en-US')}`;

export const serviceById = (id) => MAINTENANCE_SERVICES.find((service) => service.id === id);

export const serviceWhatsAppLink = (service) =>
    `https://wa.me/18297163555?text=${encodeURIComponent(`Hola, me interesa el ${service.name} para mi bicicleta.`)}`;
